import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'

const types = ["Baremo", "Junta Inicial - Especial", "Junta Primaria", "Junta Secundaria", "Junta Ed. Técnico Profesional"];
const locations = ["Provincial", "28 de Noviembre", "Los Antiguos", "El Calafate", "Caleta Olivia", "El Chaltén", "Cañadón Seco", "Puerto Deseado", "Julia Dufour", "Fitz Roy", "Gobernador Gregores", "Las Heras", "Jaramillo", "Koluel Kaike", "Piedrabuena", "Perito Moreno", "Río Gallegos", "Rospentek", "Puerto San Julián", "Puerto Santa Cruz", "Pico Truncado", "Río Turbio", "Lago Posadas", "Las Vegas", "Tres Lagos", "Camusu Aike", "Fuentes del Coyle", "El Cóndor", "Glen Cross", "Tellier", "Bajo Caracoles", "Bella vista"];
const listings = ["Provisorio", "Definitivo", "Complementario"];

class JuntaForm extends React.Component {

    constructor(props) {
        super(props);
        this.initialState = {
            isFormShow: true,
            uid: '',
            title: '',
            type: '',
            location: '',
            listing: ''
        }
        if (props.itemToEdit) {
            props.itemToEdit.isFormShow = true;
            this.state = props.itemToEdit
        } else {
            this.state = this.initialState;
        }
    }

    handleShowForm = () => {
        this.setState(this.initialState);
        this.setState({
            isFormShow: !this.state.isFormShow
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { uid, title, type, location, listing } = this.state;
        this.props.handleSubmit(uid, type, title, location, listing);
        this.setState(this.initialState);
    }

    render() {
        const { isFormShow, title, type, location, listing } = this.state;
        const textButtom = isFormShow ? 'Ocultar Formulario' : 'Mostrar Formulario';
        const iconButton = isFormShow ? faAngleUp : faAngleDown;

        const isInvalid = title === '' || !type || type === '' || !location || location === '' || !listing || listing === '';

        return (
            <div>
                <div className="accordion" id="accordionOfferForm">
                    <div className="nav justify-content-end">
                        <button onClick={this.handleShowForm} className="btn btn-dark btn-sm" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                            {textButtom}
                            <FontAwesomeIcon className="ml-2" icon={iconButton} />
                        </button>
                    </div>
                    <div id="offerFormCollapse" className="collapse show" data-parent="#accordionOfferForm">
                        <div className="pt-2 pl-3 pr-3">
                            <form onSubmit={this.handleSubmit}>
                                <div className="">
                                    <div className="row">
                                        <div className="col col-12 p-2">
                                            <input className="form-control" value={title} type="text" onChange={this.handleChange} name="title" placeholder="Título" />
                                        </div>

                                        <div className="col col-12 col-md-4 p-2">
                                            <select value={type} onChange={this.handleChange} name="type" className="form-control">
                                                <option value="">Seleccione una categoría ...</option>
                                                {types.map((item, index) =>
                                                    <option key={index} value={item}>{item}</option>
                                                )}
                                            </select>
                                        </div>

                                        <div className="col col-12 col-md-4 p-2">
                                            <select value={location} onChange={this.handleChange} name="location" className="form-control">
                                                <option value="">Seleccione una localidad ...</option>
                                                {locations.map((item, index) =>
                                                    <option key={index} value={item}>{item}</option>
                                                )}
                                            </select>
                                        </div>

                                        <div className="col col-12 col-md-4 p-2">
                                            <select value={listing} onChange={this.handleChange} name="listing" className="form-control">
                                                <option value="">Seleccione un listado...</option>
                                                {listings.map((item, index) =>
                                                    <option key={index} value={item}>{item}</option>
                                                )}
                                            </select>
                                        </div>

                                        <div className="col-12 nav justify-content-end p-2">
                                            <button disabled={isInvalid} type="submit" className="btn btn-success">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default JuntaForm;